export default "__VITE_ASSET__CghrbhjN__"